// repositories/websiteRepository.ts
import type { NitroFetchRequest, $Fetch } from 'nitropack'

// 1) Define the structure of the API responses
export interface InitializationResponse {
  data: {
    about_us: string
    youtube: string
    snapchat: string
    x: string
    instagram: string
    tiktok: string
    // ... other fields
    application_settings: {
      app_name: string
      app_icon: string
      // ... other fields
    }
    pages: {
      label: string
      id: number
      content: string
      visible: boolean
    }[]
    sections: {
      id: number
      name: string
    }[]
  }
  status: boolean
  message: string
  appended_data: Record<string, unknown>
}

export interface SectionsResponse {
  data: {
    id: number
    name: string
  }[]
  status: boolean
  message: string
  appended_data: Record<string, unknown>
}

// 2) Create the repository with additional getSections function
export const websiteRepository = <T>(fetch: $Fetch<T, NitroFetchRequest>) => ({
  async getInitialization(): Promise<InitializationResponse> {


    return await fetch<InitializationResponse>('/initialization')
  },
  async getSections(): Promise<SectionsResponse> {
    return await fetch<SectionsResponse>('/sections')
  },
  async getCities(): Promise<SectionsResponse> {
    return await fetch<SectionsResponse>('/cities')
  }
})
